export const SCREEN_SM = 576;
export const SCREEN_MD = 768;
export const SCREEN_LG = 992;
export const SCREEN_XL = 1200;

export const IsExtraSmall = () => window.innerWidth < SCREEN_SM;
export const IsSmallScreen = () => window.innerWidth >= SCREEN_SM;
export const IsMediumScreen = () => window.innerWidth >= SCREEN_MD;
export const IsLargeScreen = () => window.innerWidth >= SCREEN_LG;
export const IsExtraLargeScreen = () => window.innerWidth >= SCREEN_XL;

export const IsSmallScreenExclusive = () => window.innerWidth >= SCREEN_SM && window.innerWidth < SCREEN_MD;
export const IsMediumScreenExclusive = () => window.innerWidth >= SCREEN_MD && window.innerWidth < SCREEN_LG;
export const IsLargeScreenExclusive = () => window.innerWidth >= SCREEN_LG && window.innerWidth < SCREEN_XL;
export const IsExtraLargeScreenExclusive = () => window.innerWidth >= SCREEN_XL;

export const GetFullHeight = (el: any) => {
    const computedStyle = window.getComputedStyle(el) || {};
    if (computedStyle.display == 'none') {
        return 0;
    }
    return (
        // margin
        parseInt(computedStyle.marginTop || '0') +
        parseInt(computedStyle.marginBottom || '0') +
        el.offsetHeight || 0
    );
};
export const GetPaddingHeight = (el: any) => {
    const computedStyle = window.getComputedStyle(el) || {};
    return (
        // margin
        parseInt(computedStyle.paddingTop || '0') +
        parseInt(computedStyle.paddingBottom || '0')
    );
};